// extracted by mini-css-extract-plugin
export default {"nudge-status-container":"nudge-status-container","extra-margin":"extra-margin","nudge-status-message-container":"nudge-status-message-container"};